
import React, { Component } from "react"
import { graphql,Link } from "gatsby"
import Layout from "../components/layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import CommentList from "../components/comment-list"
import CommentForm from "../components/comment-form"
import BannerPost from "../components/banner-post"
import TopArticles from "../components/top-articles"

const dictionary = require("../dic/dic.json");
// const languageIds = require("../dic/ids.json");

class PostTemplate extends Component {

    constructor(props) {
      super(props);
    }
    addScript(url){
      const script = document.createElement("script")
      script.src = url
      script.async = false
      document.body.appendChild(script)
    }


    // componentDidMount(){
    //  this.addScript("https://www.google.com/recaptcha/api.js");
    //
    // }
    // removeScript(scriptToremove){
    //   let allsuspects=document.getElementsByTagName("script");
    //   for (let i=allsuspects.length; i>=0; i--){
    //     if (allsuspects[i] && allsuspects[i].getAttribute("src")!==null
    //       && allsuspects[i].getAttribute("src").indexOf(`${scriptToremove}`) !== -1 ){
    //                allsuspects[i].parentNode.removeChild(allsuspects[i])
    //       }
    //   }
    // }
    // componentWillUnmount() {
    //   this.removeScript("https://www.google.com/recaptcha/api.js");
    // }

    render() {
        const post = this.props.data.wpPost;
        const langPage=post.locale.id;
        const destacados = this.props.data.wpCategory.posts.nodes;
        const seo= post.seo;
        var slugPage=seo.canonical;

        // {slugPage.substring(slugPage.length-1)==='/'?slugPage=slugPage.substring(0,slugPage.length -1):slugPage=slugPage}
        var openGraphslugPage=seo.opengraphUrl;

        // {openGraphslugPage.substring(openGraphslugPage.length-1)==='/'?openGraphslugPage=openGraphslugPage.substring(0,openGraphslugPage.length -1):openGraphslugPage=openGraphslugPage}
		    const nodepostCat= post.categories.nodes;
        const bannerContent = this.props.data.wpPage.page_content.contentRaw;
        // var sourceUrlPost=null;
        // var widthUrlPost=null;
        // var HeightUrlPost=null;
        // {if(seo.twitterImage==null){
        //   sourceUrlPost=seo.opengraphImage.sourceUrl;
        //   widthUrlPost=seo.opengraphImage.mediaDetails.width;
        //   HeightUrlPost=seo.opengraphImage.mediaDetails.height;
        // } else{
        //   sourceUrlPost=seo.twitterImage.sourceUrl;
        //   widthUrlPost=seo.twitterImage.mediaDetails.width;
        //   HeightUrlPost=seo.twitterImage.mediaDetails.height;
        // }}
        var categoria=null;
        var main_cat_slug=null;
        for( var i in nodepostCat){
			//console.log('nopostCat',nodepostCat[i]);
            if(nodepostCat[i].ancestors!=undefined && nodepostCat[i].ancestors!=null){
                categoria=nodepostCat[i];
				//console.log("XXXXXXXXXX"+categoria)
            }else{
              // if(nodepostCat[i].databaseId==102 || nodepostCat[i].databaseId==99){
                  main_cat_slug=nodepostCat[i].slug;
              // }
            }
        }
        var relacionados=this.props.data.wpPost.relacionadosGroup.relacionados!=null ? this.props.data.wpPost.relacionadosGroup.relacionados : [];
        var relacionadosImportados=this.props.data.allWpPost.edges;
        //console.log("Importados",relacionadosImportados);
        for(var i in relacionadosImportados){
          relacionados.push(relacionadosImportados[i].node);
        }
        const lang= this.props.pageContext.idioma;
        return (
            <Layout langPage={lang}>
			<SEO title={seo.title} description={seo.metaDesc}  canonical={slugPage} robotsNofollow={seo.metaRobotsNofollow} robotsNoindex={seo.metaRobotsNoindex} openGraphSite={seo.opengraphSiteName} openGraphType={seo.opengraphType}  openGraphUrl={openGraphslugPage} openGraphImg={seo.opengraphImage!==null ? seo.opengraphImage.sourceUrl : "/images/logo-billage-default-social-share.jpg"} openGraphImgWidth={seo.opengraphImage!==null ?  seo.opengraphImage.mediaDetails.width : 300 } openGraphImgHeight={seo.opengraphImage!==null ? seo.opengraphImage.mediaDetails.height : 300} dctermsCreated={post.date} dctermsModified={post.modified} lang={langPage.substring(0,2)} twitterImg={seo.twitterImage!==null ? seo.twitterImage.sourceUrl : "/images/logo-billage-default-social-share.jpg"} twitterImgHeight={ seo.twitterImage!==null ? seo.twitterImage.mediaDetails.height : 300 } twitterImgWidth={seo.twitterImage!==null ? seo.twitterImage.mediaDetails.width : 300}/>
			<div className="boton-mobile-blog-container">
        		<Link to="https://app.getbillage.com/saas/register/view-register?_ga=2.54942059.1956567209.1623063776-624815792.1621270004" className="hidden-md hidden-lg boton boton-arrow boton-mobile-blog" tagert="_blank" rel="noopener noreferrer">
            {dictionary[lang].empieza_gratis}
        		</Link>
    		</div>
              <div id="page-content" className="post-page" vocab="http://schema.org/" typeof="BlogPosting" resource={slugPage}>
                  <div className="wrapper wrapper-post container">
					<div className="row">
			<div className="col-12 col-lg-8 postcontent">
			{post.featuredImage!=null && post.featuredImage.node!=null && post.featuredImage.node.localFile!=null
			?
        <Img
        fluid={post.featuredImage.node.localFile.childImageSharp.fluid} alt={post.featuredImage.node.altText}
        />
			:
				null
			}

			<div className="infopost">

        {post.author!=null
          ?
          <div className="author col-12 center">
          <div className="gravatar"><img src={post.author.node.avatar.url}/></div>
  					{post.author.node.name}
          </div>
          :
          null
        }

        {categoria!==null
        ?
          <div className="link-category">
  				<Link to={`/${lang}/blog/${categoria.slug}`}>
  				{categoria.name}
  				</Link>
  			  </div>
        :
          null
        }
			  <div dangerouslySetInnerHTML={{ __html: post.date }} className="link-date"/>
			</div>

      <h1 dangerouslySetInnerHTML={{ __html: post.title }} />
			<hr/>
			<aside className="social-share">
                        <ul className="blog-social">
                            <li className="li-facebook">
								<Link target="_blank" rel="noopener noreferrer" to={"https://www.facebook.com/sharer.php?u=https://www.getbillage.com"+post.uri} title="Facebook"><i className="fa fa-facebook"></i></Link></li>
                            <li className="li-twitter">
								<Link target="_blank" rel="noopener noreferrer" to={"https://twitter.com/share?text='"+post.title+"'&url=https://www.getbillage.com"+post.uri} title="Twitter"><i className="fa fa-twitter"></i></Link></li>
							<li className="li-linkedin">
								<Link target="_blank" rel="noopener noreferrer" to={"https://linkedin.com/shareArticle?mini=true&title='"+post.title+"'&url=https://www.getbillage.com"+post.uri} title="Linkedin"><i className="fa fa-linkedin"></i></Link></li>
                        </ul>
             </aside>
			<div className="postbody">
      			<div dangerouslySetInnerHTML={{ __html: post.content }} />
			</div>
      <div className="postlower">
					<section className="commentsection" id="comentarios">
					    <CommentList postId={post.id} comments={post.comments} lang={lang}/>
              <CommentForm postId={post.databaseId} lang={lang}/>

					</section>
					<footer className="backtotop">
						<a href="#"><i className="fa fa-chevron-circle-up"></i></a>
					</footer>
				</div>
			</div>
			<div className="col-12 col-lg-4 columnalatpost">
    			<div className="sidebar">
        			<div className="widget main_navigation">
        				<BannerPost content={bannerContent}/>
        			</div>
        			<section className="widget relatedposts">
        				{relacionados.length > 0?<h3 className="title-section">{dictionary[lang].title_relacionados}</h3>:null}
                    {relacionados.length > 0
                    ?
                        relacionados.map( relacionado => {
                            //saber cual es la categoria padre para utilizar en url
                            const nodeRel= relacionado.categories.nodes;
                            var categoria;
                            for( var i in nodeRel){
                                if(nodeRel[i].ancestors!=null){
                                    categoria=nodeRel[i].ancestors.nodes[0].slug;
                                }
                            }

                            return (<article>

                                <Link to={`/${lang}/blog/${relacionado.slug}`} className="feature">

                                  {relacionado.featuredImage!=null && relacionado.featuredImage.node!=null && relacionado.featuredImage.node.localFile!=null
                                  ?
                                  <Img
                                  fluid={relacionado.featuredImage.node.localFile.childImageSharp.fluid}
                                  />
                                  :
                                  null
                                  }
                                </Link>
                                <span className="title"><Link to={`/${lang}/blog/${relacionado.slug}`}>{`${relacionado.title}`}</Link></span>

                            </article>);
                        })
                    :
                        null
                    }
                </section>
                	<section className="widget latestposts">
                    {destacados.length!==0
                      ?
                        <TopArticles destacados={destacados} lang={lang} categoria={`blog`}/>
                      :
                        null
                    }

                  </section>
    			   </div>
          </div>
				</div>
              </div>
			</div>
            </Layout>
        )
    }
}

// featuredImage {
//   node {
// 	srcSet
// 	sourceUrl
//   }
// }
export default PostTemplate

export const pageQuery = graphql`
    query currentPostQuery($id: String!,$bannerId: Int,$relatedImportedPosts:[Int]!) {
        wpPost(id: { eq: $id }) {
            title
            id
            databaseId
            content
			      date(formatString: "D/MM/YYYY")
            modified
            uri
            locale{
              id
            }
            seo {
              canonical
              title
              metaDesc
              metaRobotsNofollow
              metaRobotsNoindex
              opengraphAuthor
              opengraphDescription
              opengraphSiteName
              opengraphTitle
              opengraphType
              opengraphUrl
              opengraphPublisher
              opengraphImage {
                altText
                sourceUrl
                title
                mediaDetails {
                  height
                  width
                }
              }
              twitterDescription
              twitterTitle
              schema {
                pageType
              }
              twitterImage {
                altText
                mediaDetails {
                  height
                  width
                }
                sourceUrl
              }
            }
  			    categories {
            		nodes {
        					databaseId
        					name
        					slug
							ancestors {
								nodes {
								  slug
								  name
								}
							 }
             }
          	}
            featuredImage {
                node {
                  altText
                  srcSet
                  sourceUrl
                  localFile {
                    childImageSharp {
                      fluid(maxWidth: 1200) {
                        ...GatsbyImageSharpFluid_withWebp
                      }
                    }
                  }

                }

              }
            comments {
              nodes {
                content
                date
                author {
                  node {
                    name
                    email
                    url
                  }
                }
              }
            }
      			author {
      				node {
              			name
              			slug
          					avatar {
          					  url
          					}
        			}
        		}
            relacionadosGroup {
              relacionados {
                ... on WpPost {
                  id
                  title
                  slug
                  featuredImage {
                    node {
                      srcSet
                      sourceUrl
                      localFile {
                        childImageSharp {
                          fluid(maxWidth: 1200) {
                            ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }

                    }

                  }
                  categories {
                    nodes {
                      slug
                      databaseId
                      ancestors {
                        nodes {
                          slug
                        }
                      }
                    }
                  }
                }
              }
            }
        }
        allWpPost(filter: {databaseId: {in: $relatedImportedPosts}}){
          edges {
            node {
              id
              title
              slug
              featuredImage {
                node {
                  srcSet
                  sourceUrl
                  localFile {
                    childImageSharp {
                      fluid(maxWidth: 1200) {
                        ...GatsbyImageSharpFluid_withWebp
                      }
                    }
                  }
                }
              }
              categories {
                nodes {
                  databaseId
                  name
                  slug
                  ancestors {
                    nodes {
                      slug
                      name
                    }
                   }
                 }
              }
            }
          }
        }

        wpPage(databaseId: {eq: $bannerId}) {
          page_content {
            contentRaw
          }
        }

        wpCategory(databaseId: {eq: 6462}) {
          databaseId
          name
          slug
          posts {
            nodes {
              databaseId
              title
              slug
              featuredImage {
                node {
                  srcSet
                  sourceUrl
                  localFile {
                    childImageSharp {
                      fluid(maxWidth: 300) {
                        ...GatsbyImageSharpFluid_withWebp
                      }
                    }
                  }

                }

              }
            }
          }
        }
    }
`
